export default __webpack_public_path__ + "static/media/sort_asc.176d7ba6.svg";